import type React from 'react';

import { useIsFromLarge } from '../../../../../common/components/atoms/ResponsiveBreakpoints';
import VariantSelector from '../../../../../common/components/atoms/VariantSelector';
import styles from './ProductDetails.module.scss';

const ProductDetailsVariantSelector = (
    props: Omit<
        React.ComponentProps<typeof VariantSelector>,
        'triggerSize' | 'triggerAs' | 'triggerFullWidth'
    > & { productName: string },
) => {
    const isFromLarge = useIsFromLarge();

    return (
        <div className={styles.VariantSelectorContainer}>
            <VariantSelector
                selectedVariantId={props.selectedVariantId}
                variants={props.variants}
                handleVariantChange={props.handleVariantChange}
                renderSelectedText={(selectedText) => (
                    <span
                        aria-label={`${selectedText}, variant vald för ${props.productName}, klicka för att ändra`}
                    >
                        {selectedText}
                    </span>
                )}
                triggerFullWidth={!isFromLarge}
            />
        </div>
    );
};

export default ProductDetailsVariantSelector;
